import PropTypes from "prop-types";
import React, { useState } from "react";
import Heading from "../../elements/heading";
import PrimaryButton from "../../elements/primary-button";
import Modal from "./../Modal";
import "./style.scss";
import BodyText from "../../elements/body-text";
import Checkbox from "../../elements/checkbox";
import { connect } from "react-redux";
import { selectUserState } from "../../selectors/application";
import api from "../../utils/api";
import { setUserInfoAction } from "../../redux/actions";
import { multiBindConsents } from "../../services/consentService";
import { getUserInfo } from "../../services/userService";
import { accountAddInfo } from "../../services/caseInfo";

function MembershipModal({
  user,
  lang,
  summaryCommons,
  becomeAMemberChangelevel = false,
  selectedLevel,
  ctaName,
  termsAndConditions,
  colorScheme,
  iconName,
  link,
  disclaimer,
  headingType,
  headingBody,
  body,
  errorMessage,
  checkboxLabel,
  checkboxBody,
  history,
  skipSubmit = false,
  onCloseClicked = () => {},
  setUserInfo = () => {}
}) {
  const [termsAgrred, setTermsAggreed] = useState(false);
  const [checkboxError, setCheckboxError] = useState(false);
  const [submitError, setSubmitError] = useState(false);

  const onCheckboxChange = isChecked => {
    setCheckboxError(false);
    setTermsAggreed(isChecked);
  };
  const setCountryLang = async () => {
    if (lang?.toLocaleLowerCase() === "en") {
      user.membershipCode = selectedLevel.value;
      setUserInfo(user);
      return null;
    }
    let countryLang = null;
    try {
      countryLang = await api.site.get(null, { key: lang });
      await api.user.countrylang.update(null, {
        preferredCountry: countryLang?.CountryLocal,
        preferredLanguage: countryLang?.CountryLang,
        userAccount: user.userAccount
      });
      const newUser = await getUserInfo();
      setUserInfo(newUser);
    } catch (err) {
      console.dir(err);
    }
  };
  const onSubmit = async evt => {
    if (termsAndConditions.length > 0 && !termsAgrred) {
      setCheckboxError(true);
      return;
    }
    if (selectedLevel.value === "MEMBERSHIP04" && user?.membershipCode !== selectedLevel.value && becomeAMemberChangelevel) {
      accountAddInfo({
        customerNumber: user?.customerNumber,
        color: summaryCommons?.color?.preSelectValue?.defaultLanguageValue,
        engine: summaryCommons?.engine?.preSelectValue?.defaultLanguageValue
      });
    }
    if (["MEMBERSHIP01", "MEMBERSHIP02", "MEMBERSHIP03"].includes(selectedLevel.value) && !skipSubmit) {
      try {
        await api.user.membership.update(null, {
          userAccount: user.userAccount,
          membershipLevel: selectedLevel.value
        });
        await setCountryLang();
        const termsAndConditionNos = termsAndConditions.map(t => t.id);
        const consentNos = [...termsAndConditionNos];
        await multiBindConsents(user.email, user.countryId, consentNos);
        if (history) {
          accountAddInfo({
            customerNumber: user?.customerNumber,
            color: summaryCommons?.color?.preSelectValue?.defaultLanguageValue,
            engine: summaryCommons?.engine?.preSelectValue?.defaultLanguageValue
          });
          history.push(link.value.href ? link.value.href : link.value.url);
        }
        onCloseClicked();
      } catch (ex) {
        setSubmitError(true);
      }
    } else {
      if (history) {
        history.push(link.value.href ? link.value.href : link.value.url);
      }
      onCloseClicked();
    }

    /*
    contiue to next step ...
    level 0-2 update mmebship to backend
    level 3 contiune to become a member flow and checkout.
    */

    // if request fail setSubmitError(true)

    // on success close modal
  };

  return (
    <Modal className="membership-modal" showModal="true" onCloseClicked={onCloseClicked}>
      <div className="membership-modal-heading">
        <Heading type={headingType} html={headingBody} typographyClass="type-h1" />
      </div>
      <div className="membership-modal-body">
        <BodyText html={body.value} />
      </div>
      {termsAndConditions.length > 0 && (
        <div className="membership-modal-checkbox">
          <Checkbox
            {...{
              label: checkboxLabel.value,
              infoText: checkboxBody.value,
              error: checkboxError,
              onChange: isChecked => onCheckboxChange(isChecked)
            }}
          />
        </div>
      )}

      {errorMessage && submitError && <BodyText className="failed-message" html={errorMessage.value} />}

      <div className="membership-modal-button">
        <PrimaryButton
          {...{
            colorScheme,
            iconName,
            link: {
              value: {
                text: ctaName.value
              }
            },
            callback: evt => onSubmit(evt)
          }}
        />
      </div>
      {disclaimer && (
        <div className="membership-modal-disclaimer">
          <BodyText html={disclaimer.value} className="disclaimer" />
        </div>
      )}
    </Modal>
  );
}

const mapStateToProps = state => ({
  user: selectUserState(state),
  summaryCommons: state.becomeAMemberSummary
});
const mapDispatchToProps = dispatch => ({
  setUserInfo: data => dispatch(setUserInfoAction(data))
});
export default connect(mapStateToProps, mapDispatchToProps)(MembershipModal);
MembershipModal.propTypes = {
  ctaName: PropTypes.object,
  colorScheme: PropTypes.object,
  iconName: PropTypes.object,
  link: PropTypes.object,
  disclaimer: PropTypes.object,
  headingType: PropTypes.object,
  headingBody: PropTypes.object,
  body: PropTypes.shape({ value: PropTypes.string }),
  errorMessage: PropTypes.shape({ value: PropTypes.string }),
  checkboxLabel: PropTypes.shape({ value: PropTypes.string }),
  checkboxBody: PropTypes.shape({ value: PropTypes.string }),
  consent: PropTypes.object,
  onCloseClicked: PropTypes.func
};
